import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/globals.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toast';
import { environment } from './environment/environment';
import { QueryClient, QueryClientProvider } from 'react-query';
import { reactQueryConfig } from '@/Instructure/configs/react-query';
import { ReactQueryDevtools } from 'react-query-devtools';
import CallOrder from '@/Ui/components/order/call-order';


const queryClient = new QueryClient(reactQueryConfig)

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient} >
      <div className="layout">
        <App />
        <CallOrder />
        <div id="root-modal"></div>
      </div>
      <ToastContainer delay={environment.toastDelay} />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
